<template>
  <div class="uv-card">
    <div class="uv-card-body">
      <ModuleHeader>Claves Administradores</ModuleHeader>
      <uv-data-table
        :config="config"
        :data="claves"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>
    <modal
      v-model="showModal"
      :showFooter="false"
      title="Claves Administradores"
    >
      <ClavesAdminForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      >
      </ClavesAdminForm>
    </modal>
  </div>
</template>

<script>
import uvDataTable from "../../MainComponents/DataTable.vue";
import ClavesAdminForm from "./ClavesAdminForm.vue";
import { mapGetters } from "vuex";
export default {
  name: "ClavesAdminCRUD",
  components: {
    uvDataTable,
    ClavesAdminForm,
  },
  props: ["membresia_id"],
  data() {
    return {
      TipoSDK: "",
      formIndex: 0,
      editMode: false,
      editData: {},
      indexComponent: 1,
      showModal: false,
      claves: [],
      config: {
        selectableRow: true,
        allowExport: true,
        rawText: "Claves administradores",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addMetodoPago",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editarMetodoPago",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteMetodoPago",
            require: true,
          },
        ],
        fields: [
          {
            text: "NOMBRE DE LA CLAVE",
            value: "Nomb",
          },
        ],
      },
      fullAccess: false,
      idSelected: "",
      biometricDevices: [],
      dataSDK: [],
      lastRecord: {},
    };
  },
  computed: {},
  methods: {
    async getClavesAdmin() {
      let claves = [];
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Administradores",
        );
      if (snapshot.val()) {
        let docs = Object.entries(snapshot.val());
        docs.forEach((element) => {
          claves.push({ id: element[0], ...element[1] });
        });
        this.claves = claves;
      } else {
        this.claves = [];
      }
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createMp(data);
      } else {
        this.updateMp(data);
      }
    },
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addMetodoPago") {
        this.idSelected = "";
        this.editMode = false;
        this.editData = {};
        this.toggleModal(true);
      }
      if (buttonId == "editarMetodoPago") {
        this.idSelected = idSelected[0];
        const mp = this.$pgsHelper.getById(this.claves, "id", idSelected[0]);
        this.editMode = true;
        this.editData = mp;

        this.toggleModal(true);
      }
      if (buttonId == "reportMembresia") {
        this.$router.push({ path: "/membresias/movimientos" });
      }
      if (buttonId == "deleteMetodoPago") {
        this.editMode = false;
        const mp = this.$pgsHelper.getById(this.claves, "id", idSelected[0]);
        this.deleteMp(idSelected[0]);
      }
    },
    async getMovimientos() {
      this.data_movimentos = [];
    },
    validateClientForm() {
      let valid = true;
      if (this.clientAdd.nombre == "") {
        valid = false;
      }

      if (this.clientAdd.apellidos == "") {
        valid = false;
      }

      if (this.clientAdd.email == "") {
        valid = false;
      }

      return valid;
    },
    createMp(data) {
      if (data.Dnrele) {
        data.Id = "CB_" + data.Id;
      }
      this.$swal({
        title: "¿Deseas guardar el metodo de pago?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-MetodosPago-createMetodoPago", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El Metodo de pago se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error saving metodo pago",
              result.value.data.error,
              "error",
            );
          }
        }
      });
    },
    updateMp(data) {
      this.$swal({
        title: "¿Deseas editar el metodo de pago?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-MetodosPago-updateMetodoPago", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El Metodo de pago se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error saving metodo pago",
              result.value.data.error,
              "error",
            );
          }
        }
      });
    },
    deleteMp(id) {
      let datos = { Id: id };
      this.$swal({
        title: "¿Deseas eliminar este metodo de pago?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-MetodosPago-deleteMetodoPago", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "El metodo de pago se elimino correctamente",
              "",
              "success",
            );
            //this.getClientes();
            this.$forceUpdate();
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error",
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
  },
  beforeMount: function () {},
  mounted: async function () {
    await this.getClavesAdmin();
  },
};
</script>
